var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "217.2001250000001 291.49854166666677 119.63200000000003 35.96825000000001",
    width: 115.63,
    height: 31.97,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.08 303.44C269.37 288.85 282.95 288.85 296.81 303.44C308.77 317.46 321.11 324.47 333.83 324.47C326.12 324.47 287.58 324.47 218.2 324.47C234.59 320.17 247.22 313.16 256.08 303.44Z",
    id: "a250YCh6Bb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a250YCh6Bb",
    opacity: 1,
    fill: "#f7f8fa",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a250YCh6Bb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconBottom);
export default __webpack_public_path__ + "static/media/cardIconBottom.1ae27a3fe01257fb196118714f8da967.svg";
export { ForwardRef as ReactComponent };